module.exports = __webpack_public_path__ + "static/media/GoFabric_white.ad0b378b.png";